module.exports = __webpack_public_path__ + "8f179495ce94f5de1dd3b6ee52e33c15.png";